module.exports = __webpack_public_path__ + "static/media/3.5f40a247.jpg";